var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26625 11.1694C3.36895 9.89748 3.94677 8.71082 4.88473 7.84558C5.82269 6.98033 7.05203 6.49994 8.32812 6.5H30.6719C31.9594 6.49995 33.1988 6.98893 34.1394 7.86803C35.0801 8.74713 35.6517 9.9507 35.7386 11.2352L19.5016 19.7844L3.26625 11.1694ZM3.25 13.4607V27.4219C3.25 28.7687 3.78502 30.0603 4.73735 31.0127C5.68968 31.965 6.98132 32.5 8.32812 32.5H30.6719C32.0187 32.5 33.3103 31.965 34.2627 31.0127C35.215 30.0603 35.75 28.7687 35.75 27.4219V13.5249L19.9729 21.8319C19.8265 21.9089 19.6636 21.949 19.4982 21.9487C19.3328 21.9484 19.17 21.9078 19.0239 21.8302L3.25 13.4607Z",
    fill: "url(#paint0_linear_1694_4566)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1694_4566",
    x1: 3.25,
    y1: 3.25,
    x2: 29.763,
    y2: 39.5494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer4);
export default __webpack_public_path__ + "static/media/Offer4.0675f40a04ed309a552eb3a6cad8a21f.svg";
export { ForwardRef as ReactComponent };